var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.225,
    stroke: "#46494B",
    strokeWidth: 1.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.25C8.58579 6.25 8.25 6.58579 8.25 7V12.5556V17C8.25 17.4142 8.58579 17.75 9 17.75C9.41421 17.75 9.75 17.4142 9.75 17V13.3056H13.2222C15.1706 13.3056 16.75 11.7261 16.75 9.77778C16.75 7.82944 15.1706 6.25 13.2222 6.25H9ZM9.75 7.75V11.8056H13.2222C14.3421 11.8056 15.25 10.8977 15.25 9.77778C15.25 8.65787 14.3421 7.75 13.2222 7.75H9.75Z",
    fill: "#46494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.a8e56918a68e1696f1485a6dbd58840d.svg";
export { ForwardRef as ReactComponent };